module.exports = __webpack_public_path__ + "static/media/logo.8fb8cda7.svg";